import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import logo from "../../images/PPKM_Head.png";
import { Button, Card } from "@mui/material";
import { CgProfile } from "react-icons/cg";
import {
  MdOutlineNotificationsActive,
  MdNotificationsActive,
} from "react-icons/md";
import "./drawer.css";
import { useNavigate } from "react-router-dom";
import { IoMdHome } from "react-icons/io";
import { BsQrCode } from "react-icons/bs";
import { LuCalendarSearch } from "react-icons/lu";
import { GrGallery } from "react-icons/gr";
import { MdOutlineSource } from "react-icons/md";
import GroupsIcon from "@mui/icons-material/Groups";
import MmsIcon from "@mui/icons-material/Mms";
import AssessmentIcon from "@mui/icons-material/Assessment";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import CellTowerIcon from "@mui/icons-material/CellTower";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

export default function MiniDrawer() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const icons = [
    <IoMdHome />,
    <BsQrCode />,
    <LuCalendarSearch />,
    <GrGallery />,
    <MdOutlineSource />,
  ];

  // Add an array for corresponding routes
  const routes = [
    "/dashboard",
    "/my_event",
    "/discover_event",
    "/gallery",
    "/document",
  ];

  const committeeIcons = [
    <GroupsIcon />,
    <MmsIcon />,
    <AssessmentIcon />,
    <FileCopyIcon />,
    <CellTowerIcon />,
  ];

  const committeeRoutes = [
    "/manage_meetings",
    "/manage_galleries",
    "/manage_polls",
    "/manage_resources",
    "/manage_notifications",
  ];

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar className="wide-header" position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={[
              {
                marginRight: 5,
              },
              open && { display: "none" },
            ]}
          >
            <MenuIcon />
          </IconButton>
          <div className="container-fluid ">
            <div className="dashboard-row d-flex align-items-center ">
              {/* Logo Wrapper */}
              <div
                className="col-sm-8 part2"
                onClick={() => navigate("/dashboard")}
              >
                <img src={logo} className="dashboard-logo" />
                <div className="text-group">
                  <span className="g1">PPK MALAYSIA</span>
                  <span className="g2">
                    Malaysia Shopping Malls Association
                  </span>
                </div>
              </div>
              <div className="d-flex col-sm-4 welcome2 justify-content-end">
                {/* <span>Welcome! User 1</span> */}
                <div className="d-flex align-items-center justify-content-end part3">
                  <Button className="rounded-circle" disableRipple>
                    <CgProfile onClick={() => navigate("/profile")} />
                  </Button>
                  <Button className="rounded-circle" disableRipple>
                    <MdNotificationsActive
                      onClick={() => navigate("notification")}
                    />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List
          sx={{
            marginTop: "40px",
          }}
        >
          {[
            "Dashboard",
            "My Events",
            "Discover Events",
            "Photo Gallery",
            "Resources",
          ].map((text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={[
                  {
                    minHeight: 48,
                    px: 2.5,
                  },
                  open
                    ? {
                        justifyContent: "initial",
                      }
                    : {
                        justifyContent: "center",
                      },
                ]}
                // Add onClick to navigate to corresponding route
                onClick={() => navigate(routes[index])}
              >
                <ListItemIcon
                  sx={[
                    {
                      minWidth: 0,
                      justifyContent: "center",
                      fontSize: "25px",
                      color: "black",
                    },
                    open
                      ? {
                          mr: 3,
                        }
                      : {
                          mr: "auto",
                        },
                  ]}
                >
                  {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
                  {/* Cycle through 4 icons using index % 4 */}
                  {icons[index % icons.length]}
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  sx={[
                    open
                      ? {
                          opacity: 1,
                        }
                      : {
                          opacity: 0,
                        },
                  ]}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
        {/* Second Section Header */}
        {/* <DrawerHeader>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", pl: 2 }}>
            Committee Section
          </Typography>
        </DrawerHeader>
        <Divider /> */}

        {/* Second List: Committee Features */}
        {/* <List>
          {[
            "Manage Meetings",
            "Manage Galleries",
            "Manage Polls",
            "Manage Resources",
            "Manage Notifications",
          ].map((text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={[
                  {
                    minHeight: 48,
                    px: 2.5,
                  },
                  open
                    ? {
                        justifyContent: "initial",
                      }
                    : {
                        justifyContent: "center",
                      },
                ]}
                onClick={() => navigate(committeeRoutes[index])}
              >
                <ListItemIcon
                  sx={[
                    {
                      minWidth: 0,
                      justifyContent: "center",
                      fontSize: "25px",
                      color: "black",
                    },
                    open
                      ? {
                          mr: 3,
                        }
                      : {
                          mr: "auto",
                        },
                  ]}
                >
                  {committeeIcons[index % committeeIcons.length]}
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  sx={[
                    open
                      ? {
                          opacity: 1,
                        }
                      : {
                          opacity: 0,
                        },
                  ]}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider /> */}
      </Drawer>
    </Box>
  );
}
